const API_URL = process.env.REACT_APP_BACKEND_URL;

// ============ VISITOR ID ============
const VISITOR_KEY = 'cloneia_vid';

const getVisitorId = () => {
  let vid = localStorage.getItem(VISITOR_KEY);
  if (!vid) {
    vid = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(VISITOR_KEY, vid);
  }
  return vid;
};

const isFirstVisit = () => {
  const key = 'cloneia_first_visit';
  if (!localStorage.getItem(key)) {
    localStorage.setItem(key, new Date().toISOString());
    return true;
  }
  return false;
};

// ============ TRACKING CORE ============
const sendEvent = (event, data = {}) => {
  const payload = {
    event,
    visitor_id: getVisitorId(),
    is_new_visitor: isFirstVisit(),
    referrer: document.referrer || '',
    user_agent: navigator.userAgent,
    screen: `${window.screen.width}x${window.screen.height}`,
    language: navigator.language,
    data,
  };
  if (navigator.sendBeacon) {
    navigator.sendBeacon(`${API_URL}/api/analytics/track`, JSON.stringify(payload));
  } else {
    fetch(`${API_URL}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  }
};

// ============ PAGE VIEW ============
let pageEnterTime = null;
let currentPage = null;

export const trackPageView = (page) => {
  // Send time_on_page for previous page
  if (currentPage && pageEnterTime) {
    const duration = Math.round((Date.now() - pageEnterTime) / 1000);
    if (duration > 0 && duration < 1800) {
      sendEvent('time_on_page', { page: currentPage, duration });
    }
  }
  currentPage = page;
  pageEnterTime = Date.now();
  sendEvent('page_view', { page });
};

// ============ CTA CLICK ============
export const trackCTAClick = (ctaName, page) => {
  sendEvent('cta_click', { cta: ctaName, page: page || window.location.pathname });
};

// ============ SCROLL DEPTH ============
let maxScroll = 0;
let scrollTracked = {};

const onScroll = () => {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  if (docHeight <= 0) return;
  const pct = Math.round((scrollTop / docHeight) * 100);
  if (pct > maxScroll) maxScroll = pct;

  const milestones = [25, 50, 75, 90];
  const page = window.location.pathname;
  for (const m of milestones) {
    const key = `${page}_${m}`;
    if (pct >= m && !scrollTracked[key]) {
      scrollTracked[key] = true;
      sendEvent('scroll_depth', { page, depth: m });
    }
  }
};

export const initScrollTracking = () => {
  maxScroll = 0;
  scrollTracked = {};
  window.removeEventListener('scroll', onScroll);
  window.addEventListener('scroll', onScroll, { passive: true });
};

export const stopScrollTracking = () => {
  window.removeEventListener('scroll', onScroll);
};

// ============ FORM FUNNEL ============
export const trackFormView = () => {
  sendEvent('form_view', { page: window.location.pathname });
};

export const trackFormSubmit = () => {
  sendEvent('form_submit', { page: window.location.pathname });
};

// ============ UNLOAD — flush time_on_page ============
const onBeforeUnload = () => {
  if (currentPage && pageEnterTime) {
    const duration = Math.round((Date.now() - pageEnterTime) / 1000);
    if (duration > 0 && duration < 1800) {
      sendEvent('time_on_page', { page: currentPage, duration });
    }
  }
};

export const initAnalytics = () => {
  window.addEventListener('beforeunload', onBeforeUnload);
};

export const cleanupAnalytics = () => {
  window.removeEventListener('beforeunload', onBeforeUnload);
  stopScrollTracking();
};
